import React, { useState, useEffect, useCallback } from "react";
import solvenciaApi from "@/api/Solvencia";
import Toast from "@/components/Toast/Toast";
import { FaCircle } from "react-icons/fa";
import PropTypes from "prop-types";



export const Step1 = ({ user = null, loading, setEssolvente, setLoading, show, prevCarg, requisitos, setRequisitos }) => {
  const [cedularuc, setCedularuc] = useState("");
  useEffect(() => {
    if (user) {
      setCedularuc(user.cedularuc)
    }
  }, [user]);

  const verrificaresSolvente = useCallback(async () => {
    if (!cedularuc) return;

    try {
      setLoading(true);

      const resp = await solvenciaApi.getEsSolvente(cedularuc);
      setEssolvente(resp.data.data.solvente);
      setRequisitos([resp.data.data]);
    } catch (error) {
      if (error.response?.data) {
        show({
          type: "warning",
          title: error.response.data.error,
          message: error.response.data.msg,
        });
      } else {
        const { name, message } = error;
        show({ type: "error", title: name, message });
      }
      setEssolvente(false);
    } finally {
      setLoading(false);
    }
  }, [cedularuc, setEssolvente, setRequisitos, setLoading, show]);

  useEffect(() => {
    if (!prevCarg && cedularuc) {
      verrificaresSolvente();
    }
  }, [cedularuc, prevCarg, verrificaresSolvente]);





  return (
    <>
      {loading && (
        <div className="absolute inset-0 z-[99999] flex items-center justify-center bg-white bg-opacity-80">
          <div className="flex h-80 w-full items-center justify-center gap-4">
            <div className="loading"></div>  Cargando requisitos...
          </div>
        </div>
      )}

      <Toast />

      {!loading && (
        <div className="mt-2 overflow-x-auto rounded-lg border border-gray-300">
          <table className="w-full table-auto text-left text-sm">
            <thead className="bg-gray-100 font-semibold text-gray-700">
              <tr>
                <th className="px-4 py-2">Requisito</th>
                <th className="px-4 py-2">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr className={`cursor-pointer hover:bg-gray-200`}>
                <td className="px-4 py-2">
                  Contribuyente Solvente
                </td>
                <td className="px-4 py-2">
                  <span className={`flex items-center gap-4 rounded-lg px-4 py-2 text-gray-700 ${requisitos.map((item) => {
                    return (
                      item.solvente === true ? 'text-green-500' : 'text-red-500'
                    )
                  })}`}>
                    <FaCircle /> {requisitos.map((item) => {
                      return (
                        item.solvente === true ? 'APROBADO' : 'NEGADO'
                      )
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export default Step1;

Step1.propTypes = {
  user: PropTypes.object,
  loading: PropTypes.bool,
  setEssolvente: PropTypes.func,
  setLoading: PropTypes.func,
  prevCarg: PropTypes.bool,
  requisitos: PropTypes.array,
  setRequisitos: PropTypes.func,
  show: PropTypes.func
};
